import { api_GET, api_POST } from "./_api.js";

const fiscalizacao_api = {
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Fiscalizacao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetFiscalizacaoHash: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Fiscalizacao/GetItemByHash/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetConsultaFiscalizacao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Fiscalizacao/GetConsultaFiscalizacao`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (fiscalizacao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Fiscalizacao`, fiscalizacao)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    PostRegionalExecucaoFiscalizacao: (endereco) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Fiscalizacao/PostRegionalExecucaoFiscalizacao`, endereco)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    preview: (execucaoFiscalizacao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Fiscalizacao/preview`, execucaoFiscalizacao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default fiscalizacao_api;
